module.exports = __webpack_public_path__ + "static/media/32.20c712ab.mp3";